import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { promise } from 'protractor';
import { BehaviorSubject, empty, Observable, of, pipe } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { BaseResponse, Country, ICartItem, ICountry, ICustomerAddress, IFinish, IGetAllSupportDataForCheckOutOrderDetail, IMasterData, IState, MasterData } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {
  constructor(private httpClient: HttpClient) {
    //this.GetMarketSegment().subscribe();
  }
  /*
  Lot of methods here will be removed after carefull examination

  */

  public allStatesOfUsAndCanada: any;

  public get isSpinning(): BehaviorSubject<boolean> {
    return this.SPINNER$;
  }
  public set spinning$(isloading: boolean) {
    this.SPINNER$.next(isloading);
  }
  public get getCountries$(): BehaviorSubject<ICountry[]> {
    return this.COUNTRIES$;
  }
  public set countries(countries: ICountry[]) {
    this.COUNTRIES$.next(countries);
  }
  public get getStates$(): BehaviorSubject<IState[]> {
    return this.STATES$;
  }
  public set states(states: IState[]) {
    this.STATES$.next(states);
  }

  //public set allStatesOfUsAndCanada$(states: IState[]) {
  //  this.STATESOfUSAndCanada$.next(states);
  //}
  //public get allStatesOfUsAndCanada(): BehaviorSubject<IState[]> {
  //  return this.STATESOfUSAndCanada$;
  //}

  public get getCities$(): BehaviorSubject<IMasterData[]> {
    return this.CITIES$;
  }
  public set cities(cities: IMasterData[]) {
    this.CITIES$.next(cities);
  }
  //public get getMerketSegment$(): BehaviorSubject<IMasterData[]> {
  //  if (!this.marketSegments) {
  //    this.GetMarketSegment().subscribe();
  //  }
  //  return this.MERKET_SEGMENT$;
  //}
  //public set marketSegments(merketSegmentResponse: IMasterData[]) {
  //  if (merketSegmentResponse) {
  //    this.MERKET_SEGMENT = merketSegmentResponse;

  //    this.MERKET_SEGMENT$.next(merketSegmentResponse);
  //  }
  //}
  //public get marketSegments(): IMasterData[] {
  //  if (!this.MERKET_SEGMENT && this.MERKET_SEGMENT.length === 0) {
  //    this.GetMarketSegment().subscribe();
  //  }
  //  return this.MERKET_SEGMENT;
  //}





  public get getFreightTerms$(): BehaviorSubject<IMasterData[]> {
    return this.FREIGHT_TERMS$;
  }
  public set freightTerms(feightTerms: IMasterData[]) {
    this.FREIGHT_TERMS$.next(feightTerms);
  }
  public get cartItems$(): BehaviorSubject<ICartItem[]> {
    return this.CART_ITEMS$;
  }
  public set cartItems(cartItems: ICartItem[]) {
    this.CART_ITEMS = cartItems as ICartItem[];
    this.CART_ITEMS$.next(cartItems as ICartItem[]);
  }
  public set addCartItem(cartItem: ICartItem) {
    this.CART_ITEMS.push(cartItem as ICartItem);
    this.CART_ITEMS$.next(this.CART_ITEMS as ICartItem[]);
  }
  public set updateCartItem(cartItem: ICartItem) {
    if (cartItem) {
      if (cartItem.cartItemCommonId) {
        const index = this.CART_ITEMS.findIndex(r => r.cartItemCommonId === cartItem.cartItemCommonId);
        const tempCartItem = this.CART_ITEMS.find(r => r.cartItemCommonId === cartItem.cartItemCommonId);
        if (tempCartItem) {
          this.CART_ITEMS.splice(index, 1, cartItem);
          this.CART_ITEMS$.next(this.CART_ITEMS);
        }
      }
    }
  }
  public set updateCartItems(cartItems: ICartItem[]) {
    if (cartItems) {
      cartItems.forEach((item, index) => {
        if (item.cartItemCommonId) {
          this.updateCartItem = item as ICartItem;
        }
      });
    }
  }
  public set removeCartItem(cartItemCommonId: string) {
    if (cartItemCommonId) {
      const index = this.CART_ITEMS.findIndex(r => r.cartItemCommonId == cartItemCommonId);
      const tempCartItem = this.CART_ITEMS.find(r => r.cartItemCommonId === cartItemCommonId);
      if (tempCartItem) {
        this.CART_ITEMS.splice(index, 1);
        this.CART_ITEMS$.next(this.CART_ITEMS);
      }
    }
  }
  public set removeCartItems(cartIds: string[]) {
    if (cartIds) {
      cartIds.forEach((cartId, index) => {
        if (cartId) {
          this.removeCartItem = cartId as string;
        }
      });
    }
  }
  public get getCategories$(): BehaviorSubject<MasterData[]> {
    return this.CATEGORIES$;
  }
  public set categories(categories: MasterData[]) {
    this.CATEGORIES$.next(categories);
  }
  //public get getFinishes$(): BehaviorSubject<IMasterData[]> {
  //  return this.FINISHES$;
  //}
  //public set finishes(categories: IMasterData[]) {
  //  this.FINISHES$.next(categories);
  //}
  public get customerAddressList$(): BehaviorSubject<ICustomerAddress[]> {
    if (!this.CUSTOMER_ADDRESS_LIST) {
      this.customerAddressList = [] as ICustomerAddress[];
    } else if (this.CUSTOMER_ADDRESS_LIST.length < 1) {
      this.customerAddressList = [] as ICustomerAddress[];
    }
    return this.CUSTOMER_ADDRESS_LIST$;
  }
  public set customerAddressList(addresslist: ICustomerAddress[]) {
    this.CUSTOMER_ADDRESS_LIST = addresslist as ICustomerAddress[];
    this.CUSTOMER_ADDRESS_LIST$.next(addresslist as ICustomerAddress[]);
  }
  public set addCustomerAddress(address: ICustomerAddress) {
    this.CUSTOMER_ADDRESS_LIST.push(address as ICustomerAddress);
    this.CUSTOMER_ADDRESS_LIST$.next(this.CUSTOMER_ADDRESS_LIST as ICustomerAddress[]);
  }
  public set updateCustomerAddress(address: ICustomerAddress) {
    if (address) {
      if (address.id) {
        const index = this.CUSTOMER_ADDRESS_LIST.findIndex(r => r.id === address.id);
        const tempaddress = this.CUSTOMER_ADDRESS_LIST.find(r => r.id === address.id);
        if (tempaddress) {
          this.CUSTOMER_ADDRESS_LIST.splice(index, 1, address);
          this.CUSTOMER_ADDRESS_LIST$.next(this.CUSTOMER_ADDRESS_LIST);
        }
      }
    }
  }
  public set updateCutomerAddress(addressList: ICustomerAddress[]) {
    if (addressList) {
      addressList.forEach((item, index) => {
        if (item.id) {
          this.updateCustomerAddress = item as ICustomerAddress;
        }
      });
    }
  }
  public set removeCutomerAddress(id: string) {
    if (id) {
      const index = this.CUSTOMER_ADDRESS_LIST.findIndex(r => r.id == id);
      const tempaddress = this.CUSTOMER_ADDRESS_LIST.find(r => r.id === id);
      if (tempaddress) {
        this.CUSTOMER_ADDRESS_LIST.splice(index, 1);
        this.CUSTOMER_ADDRESS_LIST$.next(this.CUSTOMER_ADDRESS_LIST);
      }
    }
  }
  public set removeCutomerAddressLIst(ids: string[]) {
    if (ids) {
      ids.forEach((id, index) => {
        if (id) {
          this.removeCutomerAddress = id as string;
        }
      });
    }
  }
  //#endregion

  //#region GENERAL Variables
  // This is for SPINNER
  private SPINNER$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //#endregion
  //#region User DATA & Operation
  private COUNTRIES$: BehaviorSubject<ICountry[]> = new BehaviorSubject<ICountry[]>([]);

  private STATES$: BehaviorSubject<IState[]> = new BehaviorSubject<IState[]>([]);
  private STATESOfUSAndCanada$: BehaviorSubject<IState[]> = new BehaviorSubject<IState[]>([]);

  private CITIES$: BehaviorSubject<IMasterData[]> = new BehaviorSubject<IMasterData[]>([]);

  //private MERKET_SEGMENT$: BehaviorSubject<IMasterData[]> = new BehaviorSubject<IMasterData[]>([]);
  //private MERKET_SEGMENT: IMasterData[] = [];
  private FREIGHT_TERMS$: BehaviorSubject<IMasterData[]> = new BehaviorSubject<IMasterData[]>([]);

  //#endregion

  //#region CART CACHE & Operation
  private CART_ITEMS$: BehaviorSubject<ICartItem[]> = new BehaviorSubject<ICartItem[]>([]);
  private CART_ITEMS: ICartItem[] = [];

  //#endregion

  //#region CATEGORIES CACHE & Operation
  private CATEGORIES$: BehaviorSubject<MasterData[]> = new BehaviorSubject<MasterData[]>([]);

  //#endregion

  //#region FINISHES CACHE & Operation
  private FINISHES$: BehaviorSubject<IMasterData[]> = new BehaviorSubject<IMasterData[]>([]);
  //#endregion

  //#region CUSTOMER ADDRESS CACHE & Operation
  private CUSTOMER_ADDRESS_LIST$: BehaviorSubject<ICustomerAddress[]> = new BehaviorSubject<ICustomerAddress[]>([]);
  private CUSTOMER_ADDRESS_LIST: ICustomerAddress[] = [];
  //#endregion
  //#region MasterDataService Api endPoints
  public GetCountries(): Observable<Array<Country>> {
    const endPoint = ConfigService.APIs.endPoints.MASTER_DATA.GET_COUNTRIES;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public GetStates(): Observable<Array<IState>> {
    const endPoint = ConfigService.APIs.endPoints.MASTER_DATA.GET_STATES;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public GetFreightTerms(): Observable<Array<MasterData>> {
    const endPoint = ConfigService.APIs.endPoints.MASTER_DATA.GET_FREIGHT_TERMS;
    return ApiService.genericObservableGet(this.httpClient, endPoint);
  }

  public GetAllSupportDataForCheckOutOrderDetail(): Observable<IGetAllSupportDataForCheckOutOrderDetail> {
    const endPoint = ConfigService.APIs.endPoints.MASTER_DATA.GET_ALL_SUPPORT_DATA_FOR_CHECKOUT_ORDER_DETAIL;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }

  public GetAllMasterDataForQuoteRequest() {
    //is states available in the service
    //is marketSegment available
    //quote type is available
    //GetMasterDataForQuoteRequest array of string marketSegment,quote type
    //received response, store the data in service
  }

  //static paint values


  public getPaintValues() {
    var paintValue: MasterData[] = [
      { name: '379A1456 Dark Bronze(#40 Painted Match)', value: "379A1456" },
      //{ name: '789G013 Dark Bronze(#40 Painted Match)', value: "789G013" },
      //{ name: '789G016 Sapphire Ice ', value: "789G016" },
      //{ name: '789G017 Hartford Mist', value: "789G017" },
      { name: '789G018 Sterling Grey', value: "789G018" },
      //{ name: '789G019 Champagne Rose', value: "789G019" },
      //{ name: '789G021 Mediterranean Mist', value: "789G021" },
      //{ name: '789G022 Tropical Jade', value: "789G022" },
      //{ name: '789G023 Terra Cota Metallic', value: "789G023" },
      //{ name: '789G024 Classic Copper', value: "789G024" },
      //{ name: '789G025 Metallic Brick', value: "789G025" },
      //{ name: '789G026 Burgundy Metallic', value: "789G026" },
      //{ name: '789G027 Platinium Ice', value: "789G027" },
      //{ name: '789G028 Arctic Blue', value: "789G028" },
      { name: '789G035 Black(#29 painted match)', value: "789G035" },
      { name: '379A1451 Gold(#26 painted match)', value: "379A1451" },
      //{ name: '789G036 Gold(#26 painted match)', value: "789G036" },
      { name: '379A1455 Champagne(#18 painted match)', value: "379A1455" },
      //{ name: '789G039 Champagne(#18 painted match)', value: "789G039" },
      { name: '379A1457 Medium Bronze(#28 painted match)', value: "379A1457" },
      //{ name: '789G046 Medium Bronze(#28 painted match)', value: "789G046" },
      { name: '379A1453 Light Sequin(#14-#17 painted match)', value: "379A1453" },
      //{ name: '789G048 Light Sequin(#14-#17 painted match)', value: "789G048" },
      { name: 'ORSL 10516 Black', value: "ORSL 10516" },
      { name: 'ORSL 21018 Deep Blue', value: "ORSL 21018" },
      { name: 'ORSL 21026 Military Blue', value: "ORSL 21026" },
      { name: 'ORSL 21030 Medium Blue', value: "ORSL 21030" },
      { name: 'PCST59103 Midnight Blue', value: "PCST59103" },
      //{ name: 'ORSL 21130 Midnight Blue', value: "ORSL 21130" },
      { name: 'ORSL 31466 Dark Ivy', value: "ORSL 31466" },
      { name: 'ORSL 31470 Light Green', value: "ORSL 31470" },
      { name: 'ORSL 31474 Interstate Green', value: "ORSL 31474" },
      { name: 'ORSL 31479 Dark Green', value: "ORSL 31479" },
      { name: 'ORSL 42939 Ivory', value: "ORSL 42939" },
      { name: 'ORSL 42942 Sandstone', value: "ORSL 42942" },
      { name: 'ORSL 42945 Sea Wolf', value: "ORSL 42945" },
      { name: 'ORSL 42949 Antique Bronze', value: "ORSL 42949" },
      { name: 'ORSL 42952 Classic Bronze', value: "ORSL 42952" },
      { name: 'ORSL 42955 Medium Bronze', value: "ORSL 42955" },
      { name: 'ORSL 42958 Sepia Brown', value: "ORSL 42958" },
      { name: 'ORSL 42963 Java Brown', value: "ORSL 42963" },
      { name: 'PCTT39218 Summer Yellow', value: "PCTT39218" },//pctt39218
      //{ name: 'ORSL 50397 Summer Yellow', value: "ORSL 50397" },//pctt39218
      { name: 'ORSL 61102 Redwood', value: "ORSL 61102" },
      { name: 'ORSL 61105 Boysenberry', value: "ORSL 61105" },
      { name: 'ORSL 61109 Claret Red', value: "ORSL 61109" },
      { name: 'ORSL 71870 Atlantic Gray', value: "ORSL 71870" },
      { name: 'ORSL 71873 Charcoal', value: "ORSL 71873" },
      { name: 'ORSL 71877 Nighthawk Gray', value: "ORSL 71877" },
      { name: 'ORSL 71880 Smoke Gray', value: "ORSL 71880" },
      { name: 'ORSL 71885 Light Gray', value: "ORSL 71885" },
      { name: 'ORSL 71889 Dove Gray', value: "ORSL 71889" },
      { name: 'ORSL 81249 Milk White', value: "ORSL 81249" },
      { name: 'ORSM 31006 Hartford Green', value: "ORSM 31006" },
      { name: 'ORSM 60775 Brick Red', value: "ORSM 60775" },
      { name: 'PCTT89278 Bone White(Powder)', value: "PCTT89278" },
      //{ name: 'ORSM 80851 Bone White', value: "ORSM 80851" },
      { name: 'UC100027 Antique Bronze', value: "UC100027" },
      { name: 'UC109846 Black', value: "UC109846" },
      { name: 'UC109848 Dove Gray', value: "UC109848" },
      { name: 'UC109850 Classic Bronze', value: "UC109850" },
      //{ name: 'UC109851 Military Blue', value: "UC109851" },
      { name: 'UC109852 Charcoal', value: "UC109852" },
      //{ name: 'UC109855 Sea Wolf', value: "UC109855" },
      { name: 'UC109856 Sandstone', value: "UC109856" },
      { name: 'UC109860 Dark Ivy', value: "UC109860" },
      //{ name: 'UC109861 Boysenberry', value: "UC109861" },
      { name: 'UC109862 Medium Bronze', value: "UC109862" },
      { name: 'UC109880 Bone White', value: "UC109880" },
      { name: 'UC109881 Hartford Green', value: "UC109881" },
      //{ name: 'UC109909 Colonial White', value: "UC109909" },
      //{ name: 'UC109986 Redwood', value: "UC109986" },
      { name: 'UC139981 DURANAR SERENGETI GRASS', value: "UC139981" },
      { name: 'UC127266 DURANAR L/G ZINC GRAY', value: "UC127266" },
      { name: 'UC55026 DURANAR BRIGHT WHITE', value: "UC55026" },
      { name: 'UC135973 DURANAR L/G BLACK MAGIC', value: "UC135973" }
    ];
    return paintValue;
  }
  public getPaintCodes() {
    var paintValue: Array<any> = [
      { name: '379A1456 Dark Bronze(#40 Painted Match)', value: "379A1456" },
      //{ name: '789G013 Dark Bronze(#40 Painted Match)', value: "789G013" },
      //{ name: '789G016 Sapphire Ice ', value: " 789G016" },
      //{ name: '789G017 Hartford Mist', value: "789G017" },
      { name: '789G018 Sterling Grey', value: "789G018" },
      //{ name: '789G019 Champagne Rose', value: "789G019" },
      //{ name: '789G021 Mediterranean Mist', value: "789G021" },
      //{ name: '789G022 Tropical Jade', value: "789G022" },
      //{ name: '789G023 Terra Cota Metallic', value: "789G023" },
      //{ name: '789G024 Classic Copper', value: "789G024" },
      //{ name: '789G025 Metallic Brick', value: "789G025" },
      //{ name: '789G026 Burgundy Metallic', value: "789G026" },
      //{ name: '789G027 Platinium Ice', value: "789G027" },
      //{ name: '789G028 Arctic Blue', value: "789G028" },
      { name: '789G035 Black(#29 painted match)', value: "789G035" },
      { name: '379A1451 Gold(#26 painted match)', value: "379A1451" },
      //{ name: '789G036 Gold(#26 painted match)', value: "789G036" },
      { name: '379A1455 Champagne(#18 painted match)', value: "379A1455" },
      //{ name: '789G039 Champagne(#18 painted match)', value: "789G039" },
      { name: '379A1457 Medium Bronze(#28 painted match)', value: "379A1457" },
      //{ name: '789G046 Medium Bronze(#28 painted match)', value: "789G046" },
      { name: '379A1453 Light Sequin(#14-#17 painted match)', value: "379A1453" },
      //{ name: '789G048 Light Sequin(#14-#17 painted match)', value: "789G048" },
      { name: 'ORSL 10516 Black', value: "ORSL 10516" },
      { name: 'ORSL 21018 Deep Blue', value: "ORSL 21018" },
      { name: 'ORSL 21026 Military Blue', value: "ORSL 21026" },
      { name: 'ORSL 21030 Medium Blue', value: "ORSL 21030" },
      { name: 'PCST59103 Midnight Blue', value: "PCST59103" },
      //{ name: 'ORSL 21130 Midnight Blue', value: "ORSL 21130" },
      { name: 'ORSL 31466 Dark Ivy', value: "ORSL 31466" },
      { name: 'ORSL 31470 Light Green', value: "ORSL 31470" },
      { name: 'ORSL 31474 Interstate Green', value: "ORSL 31474" },
      { name: 'ORSL 31479 Dark Green', value: "ORSL 31479" },
      { name: 'ORSL 42939 Ivory', value: "ORSL 42939" },
      { name: 'ORSL 42942 Sandstone', value: "ORSL 42942" },
      { name: 'ORSL 42945 Sea Wolf', value: "ORSL 42945" },
      { name: 'ORSL 42949 Antique Bronze', value: "ORSL 42949" },
      { name: 'ORSL 42952 Classic Bronze', value: "ORSL 42952" },
      { name: 'ORSL 42955 Medium Bronze', value: "ORSL 42955" },
      { name: 'ORSL 42958 Sepia Brown', value: "ORSL 42958" },
      { name: 'ORSL 42963 Java Brown', value: "ORSL 42963" },
      { name: 'PCTT39218 Summer Yellow', value: "PCTT39218" },
      //{ name: 'ORSL 50397 Summer Yellow', value: "ORSL 50397" },
      { name: 'ORSL 61102 Redwood', value: "ORSL 61102" },
      { name: 'ORSL 61105 Boysenberry', value: "ORSL 61105" },
      { name: 'ORSL 61109 Claret Red', value: "ORSL 61109" },
      { name: 'ORSL 71870 Atlantic Gray', value: "ORSL 71870" },
      { name: 'ORSL 71873 Charcoal', value: "ORSL 71873" },
      { name: 'ORSL 71877 Nighthawk Gray', value: "ORSL 71877" },
      { name: 'ORSL 71880 Smoke Gray', value: "ORSL 71880" },
      { name: 'ORSL 71885 Light Gray', value: "ORSL 71885" },
      { name: 'ORSL 71889 Dove Gray', value: "ORSL 71889" },
      { name: 'ORSL 81249 Milk White', value: "ORSL 81249" },
      { name: 'ORSM 31006 Hartford Green', value: "ORSM 31006" },
      { name: 'ORSM 60775 Brick Red', value: "ORSM 60775" },
      { name: 'PCTT89278 Bone White(Powder)', value: "PCTT89278" },
      //{ name: 'ORSM 80851 Bone White', value: "ORSM 80851" },
      { name: 'UC100027 Antique Bronze', value: "UC100027" },
      { name: 'UC109846 Black', value: "UC109846" },
      { name: 'UC109848 Dove Gray', value: "UC109848" },
      { name: 'UC109850 Classic Bronze', value: "UC109850" },
      //{ name: 'UC109851 Military Blue', value: "UC109851" },
      { name: 'UC109852 Charcoal', value: "UC109852" },
      //{ name: 'UC109855 Sea Wolf', value: "UC109855" },
      { name: 'UC109856 Sandstone', value: "UC109856" },
      { name: 'UC109860 Dark Ivy', value: "UC109860" },
      //{ name: 'UC109861 Boysenberry', value: "UC109861" },
      { name: 'UC109862 Medium Bronze', value: "UC109862" },
      { name: 'UC109880 Bone White', value: "UC109880" },
      { name: 'UC109881 Hartford Green', value: "UC109881" },
     // { name: 'UC109909 Colonial White', value: "UC109909" },
      //{ name: 'UC109986 Redwood', value: "UC109986" },
      { name: 'UC139981 DURANAR SERENGETI GRASS', value: "UC139981" },
      { name: 'UC127266 DURANAR L/G ZINC GRAY', value: "UC127266" },
      { name: 'UC55026 DURANAR BRIGHT WHITE', value: "UC55026" },
      { name: 'UC135973 DURANAR L/G BLACK MAGIC', value: "UC135973" }
    ];
    return paintValue;
  }
  //REFACTOR
  //API EndPoints
  priceBookCategories: [] = [];
  public async getPriceBookCategories(): Promise<[]> {
    if (this.priceBookCategories.length > 0) {
      return this.priceBookCategories;
    }
    else {
      const endPoint = `${ConfigService.APIs.endPoints.MASTER_DATA.GET_PRICE_BOOK_CATEGORIES}`;
      const p = ApiService.genericObservableGet(this.httpClient, endPoint).toPromise();
      await p.then(r => { this.priceBookCategories = r.data; });
    }

    return this.priceBookCategories;
  }

  public finishes: [] = [];
  public async getFinishes(): Promise<[]> {
    if (this.finishes.length > 0) {
      return this.finishes;
    }
    else {
      const endPoint = `${ConfigService.APIs.endPoints.MASTER_DATA.GET_FINISHES}`;
      const p = ApiService.genericObservableGet(this.httpClient, endPoint).toPromise();
      await p.then(r => { this.finishes = r.data; });
    }

    return this.finishes;
  }

  public marketSegments: IMasterData[] = [];
  public async getMarketSegments(excludeItem: boolean = true): Promise<IMasterData[]> {
    if (this.marketSegments.length > 0) {
      this.marketSegments = this.getMarketSegmentFiltered(this.marketSegments, excludeItem)
      return this.marketSegments;
    }
    else {
      const endPoint = ConfigService.APIs.endPoints.MASTER_DATA.GET_MARKET_SEGMENT;
      const p = ApiService.genericObservableGet(this.httpClient, endPoint).toPromise();
      await p.then(r => { this.marketSegments = r.data; });
    }
    this.marketSegments = this.getMarketSegmentFiltered(this.marketSegments, excludeItem)
    return this.marketSegments;
  }

  public getMarketSegmentFiltered(marketSegments: IMasterData[], excludeItem: boolean) {
    if (!excludeItem)
      return marketSegments;
    marketSegments = marketSegments.filter(m => m.name != 'Other Buildings');
    return marketSegments;
  }
  //#endregion

  //#endregion
}
